import React from 'react'
import { Spinner } from '../../../../ui/Spinner'

interface LoadingStateProps {
  isCheckingAppointment: boolean
  isLoading: boolean
}

export const LoadingState: React.FC<LoadingStateProps> = ({
  isCheckingAppointment
}) => {
  return (
    <div className="flex items-center justify-center py-12">
      <Spinner size="lg" />
      <span className="ml-3 text-gray-600">
        {isCheckingAppointment
          ? 'Verificando citas existentes...'
          : 'Cargando información...'}
      </span>
    </div>
  )
}